<template>
  <div id="itemsWrapper">
    <div class="columns is-half">
      <div class="column">
        <form>
          <label class="label" for="search">Zoeken</label>
          <div class="field has-addons">
            <div class="control">
              <input class="input" type="text" name="search" v-model="query">
            </div>
            <div class="control">
              <button type="button" class="button is-info" @click="search">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </form>
      </div>

      <div class="column is-one-quarter is-one-quarter-offset">
        <router-link :to="{ name: 'item-edit' }" tag="button" class="button">Nieuw item</router-link>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <ul>
          <list-item v-for="item in items.children" :key="item.id" :id="item.id" :name="item.name" :children="item.children" :matches="matches"></list-item>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import ListItem from './ListItem.vue'

  export default {
    data () {
      return {
        loading: false,
        items: [],
        query: '',
        matches: []
      }
    },
    components: {
      'list-item': ListItem
    },
    created () {
      this.fetchItems()
    },
    methods: {
      fetchItems () {
        axios
          .get('/items')
          .then(response => {
            this.items = response.data;
          });
      },
      search () {
        let query = this.query.toLowerCase()
        let find = (item) => {
          if (item.name.toLowerCase().includes(query)) {
            if (this.matches.indexOf(item.id) === -1) this.matches.push(item.id)
          } else {
            let idx = this.matches.indexOf(item.id)
            if (idx > -1) this.matches.splice(idx, 1)
          }

          if (item.children) {
            for (let child of item.children) {
              find(child)
            }
          }
        }

        find(this.items)
        this.$emit('search', this.matches)
      }
    }
  }
</script>

<style scoped>
  ul {
    padding: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/items/Items.vue